const verbOptions = [
  {id: 1, name: 'CONSUMED'},
  {id: 2, name: 'PRESENT'},
  {id: 3, name: 'REPAIR'},
  {id: 4, name: 'IN_USE'},
  {id: 5, name: 'EXPIRED'},
  {id: 6, name: 'DAMAGED'},
  {id: 7, name: 'LOST'},
]

export default verbOptions